import buildClient from '@/api/client'
import filterPageItemsQuery from '@/api/filter-page-items.gql'
import { formatVariants } from '../FilterPage/transformation-helpers'

function fetchFilterPageItemsData(ids) {
  return buildClient()
    .query(filterPageItemsQuery, { ids })
    .then(({ filterPageItems }) => {
      filterPageItems.forEach(function(item) {
        formatVariants(item)
      })
      return filterPageItems
    })
}

export default fetchFilterPageItemsData
